import { render, staticRenderFns } from "./WeekMeal.vue?vue&type=template&id=38ff0ec3&scoped=true&"
import script from "./WeekMeal.vue?vue&type=script&lang=js&"
export * from "./WeekMeal.vue?vue&type=script&lang=js&"
import style0 from "./WeekMeal.vue?vue&type=style&index=0&id=38ff0ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff0ec3",
  null
  
)

export default component.exports